// src/components/EPKCalendar.js
import React, { useContext, useEffect, useState } from "react";
import { parse, format, isAfter } from "date-fns";
import "../css/epkCalendar.css";

import { DataContext } from "./DataContext";

const EPKCalendar = () => {
    const { events, fetchEvents } = useContext(DataContext);
    const [isLoading, setIsLoading] = useState(false);

    // Helper to safely parse event dates
    const parseEventDate = (dateStr) => {
        try {
            // Handles strings like "10/17/2025 2:00:00 PM -07:00"
            return parse(dateStr, "MM/dd/yyyy h:mm:ss a XXX", new Date());
        } catch {
            return null;
        }
    };

    useEffect(() => {
        const load = async () => {
            setIsLoading(true);
            try {
                await fetchEvents();
            } catch (err) {
                console.error("Error fetching EPK events:", err);
            } finally {
                setIsLoading(false);
            }
        };

        if (!events || events.length === 0) {
            load();
        }
    }, []);//events, fetchEvents

    if (isLoading) return <p>Loading events…</p>;

    //console.log("All events:", events);
    //events.forEach((e) => {
    //    console.log("Raw start_time:", e.start_time, "Parsed:", parseEventDate(e.start_time));
    //});

    // Map events with parsedDate, filter upcoming, sort ascending
    const upcomingEvents = events
        ?.map((event) => ({
            ...event,
            parsedDate: parseEventDate(event.start_time),
        }))
        .filter((event) => event.parsedDate && isAfter(event.parsedDate, new Date()))
        .sort((a, b) => a.parsedDate - b.parsedDate);

    if (!upcomingEvents || upcomingEvents.length === 0) {
        return <p>No upcoming events.</p>;
    }

    return (
        <div className="epk-calendar">
            <h3>Upcoming Shows</h3>
            {upcomingEvents.map((event) => (
                <div key={event.id} className="epk-calendar-item">
                    <strong>
                        {event.name} – {format(event.parsedDate, "MMMM d, yyyy")} at{" "}
                        {format(event.parsedDate, "h:mm a")}
                    </strong>
                    {event.place?.name && ` • ${event.place.name}`}
                </div>
            ))}
        </div>
    );
};

export default EPKCalendar;
